import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
} from "@mui/material";
import { useThemeContext } from "../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

function CustomerTableComponent({ rows = [], columns = [] }) {
  const { mode } = useThemeContext();
  const { t } = useTranslation();

  const borderColor2 =
    mode === "dark" ? DARKCOLORS.GreyScale30 : LIGHTCOLORS.GreyScale30;

  const tableHeadColor =
    mode === "dark" ? DARKCOLORS.GreyScale80 : LIGHTCOLORS.GreyScale80;

  const textColor =
    mode === "dark"
      ? DARKCOLORS.BodyLightBackground
      : LIGHTCOLORS.BodyLightBackground;

  const backgroundColor1 =
    mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;

  const colorSuccess =
    mode === "dark" ? DARKCOLORS.Secondary500 : LIGHTCOLORS.Secondary500;

  return (
    <TableContainer
      sx={{
        maxHeight: "450px",
        overflow: "auto",
      }}
    >
      <Table
        sx={{
          borderCollapse: "collapse",
          width: "99%",
          "& .MuiTableCell-root": {
            border: "none",
          },
          padding: "0px",
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              whiteSpace: "nowrap",
              borderTop: `0.5px solid ${borderColor2}`,
              borderBottom: `0.5px solid ${borderColor2}`,
              paddingTop: "-8px",
            }}
          >
            {columns.map((column, index) => (
              <TableCell
                key={index}
                align={column.align || "left"}
                sx={{
                  color: tableHeadColor,
                  padding: "8px",
                }}
                className="venidng-sec-card-text"
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody sx={{ marginTop: "8px" }}>
          {rows?.length > 0 ? (
            rows.map((row, rowIndex) => {
              const isCredit = row.payment_type === "Credit";

              const isFailed =
                row.status === "Failed" ||
                row.status === "Partial Failure" ||
                row.status === "Partial Failed" ||
                row.status === "FAILED" ||
                row.status === "PARTIAL_FAILURE";

              return (
                <TableRow
                  key={rowIndex}
                  sx={{
                    "&:nth-of-type(even)": {
                      background: backgroundColor1,
                    },
                    whiteSpace: "nowrap",
                  }}
                >
                  {columns.map((column, colIndex) => (
                    <TableCell
                      key={colIndex}
                      align={column.align || "left"}
                      sx={{
                        color: textColor,
                        padding: "13px 8px",

                        ...(colIndex === 0 && {
                          borderTopLeftRadius: "8px",
                          borderBottomLeftRadius: "8px",
                        }),

                        ...(colIndex === columns.length - 1 && {
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                        }),
                      }}
                      className="bowl-customer-cell"
                    >
                      {column.field === "status" ? (
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "6px 10px",
                            borderRadius: "99px",

                            backgroundColor:
                              row[column.field] === "Completed"
                                ? mode === "dark"
                                  ? DARKCOLORS.Success100
                                  : LIGHTCOLORS.Success100
                                : row[column.field] === "Failed"
                                  ? mode === "dark"
                                    ? DARKCOLORS.Danger100
                                    : LIGHTCOLORS.Danger100
                                  : row[column.field] === "Partial Failure" ||
                                      row[column.field] === "Partial Failed"
                                    ? "#F2D773"
                                    : "transparent",

                            border:
                              row[column.field] === "Completed"
                                ? `1px solid ${
                                    mode === "dark"
                                      ? DARKCOLORS.Success500
                                      : LIGHTCOLORS.Success500
                                  }`
                                : row[column.field] === "Failed"
                                  ? `1px solid ${
                                      mode === "dark"
                                        ? DARKCOLORS.Danger500
                                        : LIGHTCOLORS.Danger500
                                    }`
                                  : row[column.field] === "Partial Failure" ||
                                      row[column.field] === "Partial Failed"
                                    ? "1px solid #F2D773"
                                    : "1px solid transparent",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,

                              color:
                                row[column.field] === "Completed"
                                  ? mode === "dark"
                                    ? DARKCOLORS.Success700
                                    : LIGHTCOLORS.Success700
                                  : row[column.field] === "Failed"
                                    ? mode === "dark"
                                      ? DARKCOLORS.Danger600
                                      : LIGHTCOLORS.Danger600
                                    : row[column.field] === "Partial Failure" ||
                                        row[column.field] === "Partial Failed"
                                      ? "#000000"
                                      : textColor,

                              fontFamily: "Satoshi-medium",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row[column.field] === "Completed"
                              ? t(
                                  "membershipCards.statusCompleted",
                                  "Completed"
                                )
                              : row[column.field] === "Failed"
                                ? t(
                                    "membershipCards.statusFailed",
                                    "Failed"
                                  )
                                : row[column.field] === "Partial Failure" ||
                                    row[column.field] === "Partial Failed"
                                  ? t(
                                      "membershipCards.statusPartialFailure",
                                      "Partial Failure"
                                    )
                                  : row[column.field]}
                          </Typography>
                        </Box>
                      ) : column.field === "amount" ? (
                        <Box
                          className="bowl-customer-cell"
                          display="flex"
                          alignItems="center"
                          sx={{
                            // ONLY Credit is green.
                            // Everything else is black.
                            color: isCredit ? colorSuccess : textColor,
                          }}
                        >
                          {/* + only for Credit and NOT Failed/Partial Failed */}
                          {isCredit && !isFailed && (
                            <AddIcon
                              sx={{
                                fontSize: "15px !important",
                              }}
                            />
                          )}

                          €{" "}
                          {row[column.field] != null
                            ? parseFloat(row[column.field]).toFixed(2)
                            : row[column.field]}
                        </Box>
                      ) : column.render ? (
                        column.render(row[column.field], row)
                      ) : (
                        row[column.field]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length + 2} align="center">
                {t("membershipCards.Nodataavailable")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CustomerTableComponent;